// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"9d9fbf74","239":"b68e61b2","453":"e25ff6b8","455":"f314d92f","977":"1c59e2fe"}[chunkId] + ".chunk.js";
};